/**
 * timeUtils.js
 *
 * Shared utility functions for time formatting across the application
 */

/**
 * Format a UTC ISO timestamp as a localized date/time string (e.g., "Mar 17, 2026, 4:30 PM")
 * @param {string} isoString - ISO 8601 timestamp string (naive UTC or with timezone offset)
 * @returns {string} Localized date-time string
 */
export const formatDateTime = isoString => {
  if (!isoString) return '';
  // Ensure the string is treated as UTC (backend returns naive UTC without 'Z')
  const utcString = isoString.endsWith('Z') || isoString.includes('+') ? isoString : isoString + 'Z';
  const created = new Date(utcString);
  return created.toLocaleString(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
};
